import React from "react";
import Filters from "./Filters";
import ListTemplate from "components/ListTemplate";
import { cardLayout } from "./cardLayout";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useLoaderData } from "react-router";

const TrainListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.TrainListFrontModel>();

  return <ListTemplate
    title={RESX.Train.Trains}
    filterSet="train_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Train.Paginated}
    getId={item => item.trainId}
    layout={cardLayout()}
    filters={<Filters />}
    functions={{
      mapFilterValuesToInstruction,
      mapResponseToFilterValues
    }}
  />
};

export default TrainListApp;
